import React from 'react';
import { CheckCircle, MapPin, Building, Calendar } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const TawkeOilFieldPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://images.pexels.com/photos/10407684/pexels-photo-10407684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70" />
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Tawke Oil Field
          </h1>
          <div className="flex flex-wrap justify-center gap-6 mt-6">
            <div className="flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              <span className="text-lg">Duhok Province, Kurdistan Region</span>
            </div>
            <div className="flex items-center gap-2">
              <Building className="w-5 h-5" />
              <span className="text-lg">DNO</span>
            </div>
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5" />
              <span className="text-lg">2018-2023</span>
            </div>
          </div>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Project <span className="text-red-600">Overview</span>
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" />
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              Oil field development in northern Kurdistan Region with recent completion of Peshkabir-9 and Tawke-52 wells, 
              including exploration targeting Cretaceous reservoir.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              Total Vision are working with the Subcontractors in Erbil in the form of man power secondment, technical writing, 
              Construction & Quality support and of course Field Engineering.
            </p>
          </div>

          {/* Project Scope */}
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border-none shadow-xl">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Field Development</h3>
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Peshkabir-9 well completion</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Tawke-52 well development</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Cretaceous reservoir exploration</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Production optimization initiatives</span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-none shadow-xl">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Engineering Services</h3>
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Manpower secondment</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Technical writing services</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Construction support</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Quality assurance and control</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span>Field engineering support</span>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Project Significance */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-slate-900 mb-6">Project Significance</h3>
            <p className="text-lg text-slate-700 leading-relaxed">
              The Tawke Oil Field represents a significant asset in the Kurdistan Region's energy sector. Total Vision's 
              collaborative approach with subcontractors in Erbil through manpower secondment, technical writing, construction 
              and quality support, and field engineering demonstrates our commitment to delivering comprehensive solutions. 
              Our involvement in the development of key wells including Peshkabir-9 and Tawke-52, along with exploration 
              initiatives, contributes to the sustainable development of this important oil field.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TawkeOilFieldPage;